import { render } from "./AddButton.vue?vue&type=template&id=6559ecf9&scoped=true"
import script from "./AddButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddButton.vue?vue&type=script&setup=true&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=6559ecf9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6559ecf9"],['__file',"src/components/Wishlist/AddButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6559ecf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6559ecf9', __exports__)) {
    api.reload('6559ecf9', __exports__)
  }
  
  module.hot.accept("./AddButton.vue?vue&type=template&id=6559ecf9&scoped=true", () => {
    api.rerender('6559ecf9', render)
  })

}


export default __exports__